__turbopack_context__.v({
  "checkboxesContainer": "styles-module__1dWOxq__checkboxesContainer",
});
